import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import { AuthService } from 'app/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class EmailHistoryTableService {

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  getProductos(idEmpresa:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + idEmpresa );
  }

  getProrrogasFechaCierre(datos:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.fechaCierre.getProrrogasFechaEncuesta + datos);
  }

  getStatusBanderaProrroga(idEmpresa: string, idProducto: string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getBanderasProrroga + idEmpresa + "/" + idProducto);
  }

  getPilotoDataEncuesta_estatus(datos:any, idEmpresa:string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.envioCorreo.getPilotoData + idEmpresa, datos);
  }

  getAvanceEncuesta(datos:any, idEmpresa:string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.cierre.getAvanceEncuesta + idEmpresa, datos);
  }

  getPilotoData_Pulse(datos:any, idEmpresa:string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getEncuetasPulsePiloto + idEmpresa, datos);
  }

  getFechasProgramacionPulse_status(datos: any,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getFecha + idEmpresa, datos);
  }

  surveyCheck(token:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.surveyCheck + token);
  }

  getPilotoData_medir(datos:any, idEmpresa:string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.envioCorreo.getPilotoData + idEmpresa, datos);
  }

  getAvanceEncuestaMedir(datos:any, idEmpresa:string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.cierre.getAvanceEncuesta + idEmpresa, datos);
  }

  getFechaLanzamientoStatusEncuesta(empresaId:any,data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.shedule.getFechaLanzamiento + empresaId, data);
  }

  getEstatusCierreEncuesta(datos:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.fechaCierre.getStatusEncuesta + datos);
  }

  getFechaLanzamiento35_req(datos:any, idEmpresa:string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getfecha35 + idEmpresa, datos);
  }

  normaCloseSurvey(productoId:number, tipoEncuesta:number, idEmpresa:string){
    let datos: any = { productoId, tipoEncuesta};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getsurveyclose + idEmpresa, datos);
  }

  getMostrarEncuestas(datos:any, idEmpresa:string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getEncuestas + idEmpresa, datos);
  }

  desColaboradores(idSurvey1:any ,idSurvey2:any ,bandera:any ,instituto:any){
    let datos: any = {bandera, instituto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.avanceEncuesta.downloadCol + idSurvey1 + '/' + idSurvey2, datos);
  }

  desColaboradoresV2(idSurvey1:any ,idSurvey2:any ,bandera:any, nombre:string){
    let datos: any = {bandera};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.status_survey_getcolaboradores + idSurvey1 + '/' + idSurvey2 + '/' + nombre, datos);
  }

  getCatalogos(numInstituto:any, idioma:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.avanceEncuesta.getCatalogos + numInstituto + "/" + idioma);
  }

  buscaOwnkey(idProducto:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.buscaOwnkey + idProducto, datos);
  }
  buscaBossKey(idProducto:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.buscaBossKey + idProducto, datos);
  }
  buscarSurveyKey(idProducto:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.buscarSurveyKey + idProducto, datos);
  }
  buscarEmail(idProducto:string, email:string, paramExtra:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.buscaEmail + idProducto + "/" + email + "/" + paramExtra);
  }
  updateColaborador(idColaborador:string, idSurvey:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.getSetDelColaborador + idColaborador + "/" + idSurvey, datos);
  }
  updateColaboradorFocus(idColaborador:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.update_fa + idColaborador, datos);
  }
  saveColaboradorNuevo(idEmpresa:string, idProducto:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.save + idEmpresa + '/' + idProducto, datos);
  }
  saveColaboradorNuevoFocus(idEmpresa:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.save_fa + idEmpresa, datos);
  }

  getInfoColabaradorPorPassword(productoId,password){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.buscarColaboradorPassword+productoId+'/'+ password);
  }

  getColaboradorFstStp(correo:string, productoId:string){
    let datos: any = {search : correo,page :1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.avanceEncuesta.consultarUusuario+productoId, datos);
  }

  getColaborador(idColaborador:string, idSurvey:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.getSetDelColaborador + idColaborador + "/" + idSurvey);
  }

  deleteColaborador(idColaborador:string, idSurvey:string){
    return this.http.delete(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.getSetDelColaborador + idColaborador + "/" + idSurvey, {});
  }

  getRecordatorios_correo_statussurvey(datos:any,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getemailreminder + idEmpresa, datos);
  }

  CertificarsendRecordatorio_statusSurvey(productoId,idEmpresa){
    let datos: any = {productoId};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.sendreminder + idEmpresa, datos);
  }

  CertificarsendRecordatorio_statusSurveySMTP(productoId,idEmpresa){
    let datos: any = {productoId};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.manualReminderSMTP + idEmpresa, datos);
  }

  Certificar3sendRecordatorio_statusSurveySMTP(productoId,empresaId){
    let datos: any = {productoId, empresaId, tipos:[6,7]};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.manualReminderSMTPCer3, datos);
  }

  getRecordatorios_correoGenerico_status(datos:any,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getMedirGenerico + idEmpresa, datos);
  }

  sendRecordatorioMedirGenerico_status(productoId,idEmpresa){
    let datos: any = {productoId};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.sendreminderMedirGenerico + idEmpresa, datos);
  }

  getRecordatoriosPulse_status(datos,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getRecordatoriosPulseManuales + idEmpresa, datos);
  }

  sendRecordatoriosPulse_status(datos,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.sendRecordatoriosPulse + idEmpresa, datos);
  }
}
